import u from "./ghl-ui.es1589.js";
import x from "./ghl-ui.es1590.js";
import m from "./ghl-ui.es1586.js";
import f from "./ghl-ui.es1587.js";
import l from "./ghl-ui.es1588.js";
import p from "./ghl-ui.es1591.js";
import { Parser as h } from "./ghl-ui.es1670.js";
import { timezonePatterns as n } from "./ghl-ui.es1672.js";
import { parseTimezonePattern as s } from "./ghl-ui.es1671.js";
var w = /* @__PURE__ */ function(c) {
  f(o, c);
  var a = l(o);
  function o() {
    var r;
    u(this, o);
    for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
      t[i] = arguments[i];
    return r = a.call.apply(a, [this].concat(t)), p(m(r), "priority", 10), p(m(r), "incompatibleTokens", ["t", "T", "X"]), r;
  }
  return x(o, [{
    key: "parse",
    value: function(e, t) {
      switch (t) {
        case "x":
          return s(n.basicOptionalMinutes, e);
        case "xx":
          return s(n.basic, e);
        case "xxxx":
          return s(n.basicOptionalSeconds, e);
        case "xxxxx":
          return s(n.extendedOptionalSeconds, e);
        case "xxx":
        default:
          return s(n.extended, e);
      }
    }
  }, {
    key: "set",
    value: function(e, t, i) {
      return t.timestampIsSet ? e : new Date(e.getTime() - i);
    }
  }]), o;
}(h);
export {
  w as ISOTimezoneParser
};
